(function () {
  'use strict';

  angular
    .module('app.account-returns', [])

    .component('accountReturns', {
      bindings: {
        result: '<',
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountReturns;
      }],
      /* @ngInject */
      controller: ["$scope", "$rootScope", "$element", "$timeout", "$route", "$location", "ModalService", "AccountService", "HttpService", "AppService", "toastr", "smoothScroll", function ($scope, $rootScope, $element, $timeout, $route, $location, ModalService, AccountService, HttpService, AppService, toastr, smoothScroll) {
        var ctrl = this;

        AccountService.initAccount(ctrl);
          
        ctrl.$onInit = function () {

          $scope.device = ctrl.device;

          AppService.getParams()
            .then(function (params) {
              if (!params.Account.IsManagementReturns) {
                $location.path(ctrl.links.AccountHome);
              } else {
                ctrl.activeTab = 0;
                ctrl.requests = ctrl.result.requests;
                ctrl.result = null;
                if (!ctrl.requests.length) ctrl.activeTab = 1;
                loadFolders();
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        // Translate
        var tplTranslate = {};
        $element.children('.translate').children().each(function () {
          var $this = $(this);
          tplTranslate[$this.attr('key')] = $this.html();
        });

        ctrl.removeReturn = function (event, id) {
          event.stopPropagation();
          ModalService.show(
            '/Template/Account/ModalReturnsDeleteConfirm',
            {
              action: function () {
                ctrl.cancelRequest(id);
              }
            },
            null,
            'modalRemoveReturnCtrl'
          );
        };

        // Requests
        ctrl.cancelRequest = function (idFolder) {
          $rootScope.$broadcast('showPageLoader', true);
          HttpService.post({
            url: 'AccountReturns/CancelReturnFolder',
            data: {
              idFolder: idFolder
            }
          })
            .then(function (response) {
              if (response.status === 'OK') {
                $route.reload();
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        // Orders
        ctrl.getOrder = function (order) {
          if (order.loaded) return;
          getFolderProducts(order);
        };

        ctrl.selectLine = function (order, line) {
          ctrl.orders = _.cloneDeep(ctrl.ordersList);
          ctrl.ordersList = [order];
          ctrl.idOrderSelected = order.IDFolder;
          line.selected = !line.selected;
          checkReturnDisabled();
          line.step = 1;
          if (line.Quantity === 1) {
            line.ReturnQuantity = 1;
            ctrl.quantityChange(line);
          }
          $timeout(function () {
            smoothScroll(document.getElementById('ordersTop'), {offset: 50});
          });
        };

        ctrl.backToOrders = function () {
          ctrl.idOrderSelected = null;
          ctrl.ordersList = _.cloneDeep(ctrl.orders);
          $timeout(function () {
            smoothScroll(document.getElementById('ordersTop'), {offset: 50});
          });
        };

        ctrl.refreshSelect = function () {
          refreshSelects();
        };

        ctrl.getQuantities = function (num) {
          return new Array(num);
        };
        ctrl.quantityChange = function (line) {
          unfocusSelects();
          line.step = 1;
          if (line.ReturnQuantity !== '') {
            if (!line.reasons) {
              line.loading = true;
              HttpService.post({
                url: 'AccountReturns/ReturnReasons',
                data: {
                  IDLine: line.IDLine
                }
              })
                .then(function (response) {
                  if (response.status === 'OK') {
                    line.reasons = response.results.reasons;
                  }
                  line.step = 2;
                  line.loading = false;
                })
                .catch(function (error) {
                  console.error(error);
                });
            } else {
              line.step = 2;
            }
          }
        };

        ctrl.reasonChange = function (line) {
          unfocusSelects();
          line.step = 2;

          line.InputComment = null;
          line.ReturnReason = {
            InputComment: false,
            IDReturnReason: ''
          };
          _.each(line.reasons, function (reason) {
            if (reason.IDReturnReason === line.Reason) {
              line.ReturnReason = reason;
              return false;
            }
          });
          line.InputComment = line.ReturnReason.InputComment;
          if (line.Reason !== '') {
            line.loading = true;
            HttpService.post({
              url: 'AccountReturns/ReturnActions',
              data: {
                IDLine: line.IDLine,
                IDReturnReason: line.Reason
              }
            })
              .then(function (response) {
                if (response.status === 'OK') {
                  line.actions = response.results.actions;
                  refreshSelects();
                }
                line.step = 3;
                line.loading = false;
              })
              .catch(function (error) {
                console.error(error);
              });
          }
          checkReturnDisabled();
        };

        ctrl.actionChange = function (line) {
          unfocusSelects();
          line.ReturnAction = {
            ReturnActionKey: ''
          };
          _.each(line.actions, function (action) {
            if (action.ReturnActionKey === line.ActionValue) {
              line.ReturnAction = action;
              return false;
            }
          });
          checkReturnDisabled();

          line.IDExchangeProduct = null;
          if (line.ActionValue === 'EchangeAutreProduit') {
            ModalService.show(
              '/Template/Modal/ModalQuickView',
              {
                url: 'choose-p-' + line.Product.IDGroupingProduct,
                selectPrimary: true,
                idGroupingProduct: line.Product.IDGroupingProduct,
                originalId: line.Product.IDProduct,
                line: line,
                action: ctrl.productExchange
              },
              'lg',
              'modalReturnController',
              null,
              ctrl.device,
              {
                translate: tplTranslate
              },
              function () {
                ctrl.closeProductExchange(line);
              }
            );
          }
        };

        ctrl.productExchange = function (line, id) {
          line.IDExchangeProduct = id;
        };
        ctrl.closeProductExchange = function (line) {
          if (!line.IDExchangeProduct) {
            line.ActionValue = '';
            line.ReturnAction = null;
            line.InputComment = null;
            $timeout(function () {
              $element.find('select.action').val('');
              refreshSelects();
            });
            checkReturnDisabled();
          }
        };

        ctrl.submitReturnProducts = function () {
          $rootScope.$broadcast('showPageLoader', true);
          var items = [];
          _.each(ctrl.ordersList, function (order) {
            _.each(order.Products, function (line) {
              if (line.selected === true) {
                items.push({
                  IDLine: line.IDLine,
                  Comment: line.Comment,
                  IDProduct: line.IDProduct,
                  IDReturnReason: parseInt(line.Reason),
                  IDExchangeProduct: line.IDExchangeProduct || 0,
                  Quantity: line.ReturnQuantity,
                  ReturnActionKey: line.ReturnAction.ReturnActionKey
                });
              }
            });
          });

          if (items.length) {
            HttpService.post({
              url: 'AccountReturns/ReturnProductsSend',
              data: {
                items: items,
                IDFolder: ctrl.idOrderSelected
              }
            })
              .then(function (response) {
                AppService.getTranslate()
                  .then(function (translate) {
                    if (response.status === 'OK') {
                      $route.reload();
                      toastr.success('', translate.messages.DemandOk, {
                        allowHtml: true,
                        extraData: {
                          template: 'toast_message.tpl'
                        }
                      });
                    } else {
                      $rootScope.$broadcast('showPageLoader', false);
                      toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                        allowHtml: true,
                        extraData: {
                          template: 'toast_message.tpl'
                        }
                      });
                    }
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
              })
              .catch(function (error) {
                console.error(error);
              });
          }

        };

        // Functions

        function loadFolders() {
          ctrl.ordersLoading = true;
          AccountService.getEligibleReturnFolders()
            .then(function (data) {
              ctrl.orders = data.orders;
              _.each(ctrl.orders, function (order) {
                order.Products = [];
                order.init = true;
              });
              ctrl.ordersList = _.cloneDeep(ctrl.orders);
              _.each(ctrl.ordersList, function (order) {
                order.Products = [];
                order.init = false;
                $timeout(function () {
                  order.init = true;
                }, 350);
              });

              ctrl.ordersLoading = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function getFolderProducts(order) {
          HttpService.post({
            url: 'AccountReturns/ReturnFolderProducts',
            data: order.IDFolder
          })
            .then(function (response) {
              if (response.status === 'OK') {
                order.Products = response.results.products;
              }
              order.loaded = true;
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function refreshSelects() {
          setTimeout(function () {
            $element.find('select.refresh').each(function (index, el) {
              $(el).selectpicker('refresh');
            });
          });
        }

        function unfocusSelects() {
          setTimeout(function () {
            $element.find('div.refresh').each(function (index, el) {
              $(el).find('.dropdown-toggle').blur();
            });
          });
        }

        function checkReturnDisabled() {
          ctrl.submitReturnDisabled = true;
          _.each(ctrl.ordersList, function (order) {
            _.each(order.Products, function (line) {
              if (line.selected === true) {
                ctrl.submitReturnDisabled = false;
                if (!line.Reason || line.Reason === '') {
                  ctrl.submitReturnDisabled = true;
                  return false;
                }
                if (!line.ReturnAction) {
                  ctrl.submitReturnDisabled = true;
                  return false;
                }
              }
            });
          });
        }

      }],
      controllerAs: 'accountCtrl'
    })

    /* @ngInject */
    .controller('modalRemoveReturnCtrl', ["data", "device", "options", "ModalService", function (data, device, options, ModalService) {
      var ctrl = this;
      ctrl.submit = function () {
        ModalService.close();
        data.action();
      };
    }])

    /* @ngInject */
    .controller('modalReturnController', ["data", "device", "options", "ModalService", function (data, device, options, ModalService) {
      var ctrl = this;
      ctrl.data = data;
      ctrl.device = device;
      ctrl.options = options;
      ctrl.showLoader = true;

      ctrl.onLoad = function () {
        ctrl.showLoader = false;
      };

      ctrl.selectPrimary = function (event) {
        if ($(event.currentTarget).attr('disabled')) {
          return;
        }
        ctrl.data.action(ctrl.data.line, ctrl.data.id);
        ModalService.close();
      };

      ctrl.choiceButton = function () {
        if (!ctrl.data.id || ctrl.data.id === ctrl.data.idGroupingProduct) {
          ctrl.tooltip = ctrl.options.translate.ChooseElementary;
          return true;
        }
        if (ctrl.data.id === ctrl.data.originalId) {
          ctrl.tooltip = ctrl.options.translate.IsTheSame;
          return true;
        }
        ctrl.tooltip = '';
        return false;
      };

    }]);

})();
